import type { AuthCredentials } from "@/types/api/contracts"
import { API } from "@/utils/http"

const REFRESH_TOKEN_API_URL = "/v2/backoffice/auth/refresh"
const LOGOUT_API_URL = "/v2/backoffice/auth/logout"

const signIn = async ({ mobile_phone = "", password = "" }: Partial<AuthCredentials>) => {
  const data = {
    mobile_phone,
    password
  }

  return API.post("/v2/backoffice/auth/login", data)
}

const refreshToken = async (refresh = "") => {
  return API.post(REFRESH_TOKEN_API_URL, { refresh })
}

const logout = async (accessToken = "") => {
  return API.post(LOGOUT_API_URL, null, {
    headers: { Authorization: `Bearer ${accessToken}` }
  })
}

export default {
  REFRESR_TOKEN_API_URL: REFRESH_TOKEN_API_URL,
  LOGOUT_API_URL,
  signIn,
  refreshToken,
  logout
}
